<template>
  <b-container fluid>
    <b-card-body>
      <div align="center" v-if="loader">
        <img src="../assets/cargando.gif" align="center" />
      </div>
      <div v-else>
        <FormulateForm
          id="solicitar"
          @submit="submitHandler"
          v-model="formValues"
        >
          <center>
            <h2>Plazo Fijo Web</h2>
          </center>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="8">
              <h5>Datos Persona Física</h5>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="4">
              <FormulateInput
                name="tipodoc"
                :options="{ 10: 'CUIT', 9: 'CUIL' }"
                type="select"
                label="CUIT/CUIL"
                disabled="true"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                name="documento"
                label="Numero"
                validation="^required|number"
                readonly="true"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="4">
              <FormulateInput
                name="nombre"
                label="Nombre y Apellido"
                validation="^required"
                readonly="true"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                name="email"
                label="Email"
                type="email"
                validation="^required|email"
                readonly="true"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>

            <b-col md="4">
              <FormulateInput
                name="telefono"
                label="Teléfono"
                validation="^required"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                name="calle"
                label="Calle"
                validation="^required"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>

            <b-col md="4">
              <FormulateInput
                name="altura"
                label="Numero"
                validation="^required|number"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput name="piso" label="Piso" />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>

            <b-col md="4">
              <FormulateInput name="depto" label="Departamento" />
            </b-col>
            <b-col md="4">
              <FormulateInput
                name="provincia"
                label="Provincia"
                :options="provincias"
                type="select"
                validation="^required"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>

            <b-col md="4">
              <FormulateInput
                name="localidad"
                label="Localidad"
                validation="^required"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                name="codigoPostal"
                label="Codigo Postal"
                validation="^required|number"
              />
            </b-col>
          </b-row>

          <br />
          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="8">
              <h5>Datos del Plazo Fijo</h5>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="8">
              <FormulateInput
                name="cbualias"
                label="CBU o alias de la cuenta a debitar"
                validation="^required"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="4">
              <FormulateInput
                name="fechaconstitucion"
                label="Fecha de Constitución"
                validation="^required"
                readonly="true"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                name="plazo"
                label="Plazo (días)"
                type="number"
                validation="^required|number"
                min="30"
                max="90"
                readonly="true"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="4">
              <FormulateInput
                name="capital"
                label="Capital"
                validation="^required|number"
                min="1000"
              />
            </b-col>
            <!--b-col md="4">
            <FormulateInput name="interes" label="Interés" readonly="true" />
            </b-col-->
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="8">
              <FormulateInput
                name="pep"
                :options="{ si: 'Si', no: 'No' }"
                type="radio"
                label="¿Estoy incluido y/o alcanzado dentro de la nómina de “Personas Expuestas Políticamente” (PEP) aprobada por la Unidad de Información Financiera?:"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="8">
              <FormulateInput
                name="sujeto"
                :options="{ si: 'Si', no: 'No' }"
                type="radio"
                label="¿Revisto la calidad de “Sujeto Obligado” (SO), de acuerdo al art. 20 de la Ley Nº 25.246?:"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="8">
              <FormulateInput
                name="ddjj"
                :options="{ si: 'Si', no: 'No' }"
                type="radio"
                label="¿Soy una persona humana o jurídica beneficiaria de una “financiación 
                     MiPyME acordada a tasa subsidiada de hasta TNA 24%” (Com. “A” 6937 y 
                     concordantes) y/o de un “crédito a tasa subsidiada para empresas ATP” 
                     (Com. “A” 7082); y adicionalmente, incluyendo la presente solicitud es 
                     por un importe superior a $ 1.000.000?:"
              />
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col md="2"></b-col>
            <b-col md="4">
              <FormulateInput type="submit" name="Confirmar" />
            </b-col>
          </b-row>
        </FormulateForm>
      </div>
    </b-card-body>
  </b-container>
</template>

<script>
import service from "@/logic/service.js";
import constantes from "@/logic/constantes.js";
export default {
  data() {
    return {
      formValues: {
        cbualias: "",
        tipodoc: "",
        documento: "",
        email: "",
        telefono: "",
        nombre: "",
        apellido: "",
        calle: "",
        altura: "",
        piso: "",
        depto: "",
        provincia: "",
        localidad: "",
        fechaconstitucion: "",
        plazo: "",
        capital: "",
        interes: "",
        pep: "",
        sujeto: "",
        uuid: "",
        ddjj: "",
      },
      provincias: constantes.provincias(),
      loader: true,
    };
  },

  async created() {
    try {
      this.loader = true;
      var parametros = {
        params: {
          id: this.$route.params.id,
          url: 1,
        },
      };

      const response = await service.consultar(parametros);
      //      console.log(response.data);
      if (response.data.error) {
        this.$alert(response.data.mensaje, "Importante", "warning").then(() => {
          window.location.href = "https://www.bancojulio.com.ar";
        });
      } else {
        this.formValues = response.data.plazofijo;
        this.formValues.fechaconstitucion = new Date().toLocaleDateString(
          "es-AR",
          {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
          },
        );
        (this.formValues.pep = "no"),
          (this.formValues.sujeto = "no"),
          (this.formValues.ddjj = "no"),
          (this.formValues.provincia = 4);
        this.formValues.plazo = 30;
      }
      this.loader = false;
    } catch (error) {
      const mensaje =
        "El servicio no se encuentra disponible en este momento. Por favor, Intente mas tarde.";
      this.$alert(mensaje, "Importante", "warning").then(() => {
        window.location.href = "https://www.bancojulio.com.ar";
      });
    }
  },

  methods: {
    async submitHandler() {
      this.loader = true;
      try {
        const response = await service.confirm(this.formValues);
        //        console.log(response);
        if (response.data.error) {
          this.loader = false;
          if (response.data.noReintentar) {
            this.$alert(response.data.mensaje, "Importante", "warning").then(
              () => {
                window.location.href = "https://www.bancojulio.com.ar";
              },
            );
            return;
          }
          this.$alert(response.data.mensaje);
        } else {
          const emailEnviado = response.data.emailEnviado !== false;
          const texto = emailEnviado
            ? "Se generó el DEBIN para el plazo fijo. Solo resta autorizarlo desde Home Banking o Banca Empresa."
            : "El DEBIN se generó y quedó registrado, pero no se pudo enviar el correo. No vuelva a confirmar la operación; revise su Home Banking o comuníquese con el banco.";

          this.$alert(
            texto,
            "Importante",
            emailEnviado ? "success" : "warning",
          ).then(() => {
            window.location.href = "https://www.bancojulio.com.ar";
          });
        }
      } catch (error) {
        const mensaje =
          "El servicio no se encuentra disponible en este momento. Por favor, Intente mas tarde.";
        this.$alert(mensaje, "Importante", "warning");
      }
    },
  },
};
</script>

<style scoped>
.abs-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.form {
  width: 650px;
}
</style>
